import type { Invoice } from '~/api/invoices/types';

import { Separator } from '~/components';

import { mobileActionsStyle, mobileCellStyle, mobileFooterStyle, mobileHeaderStyle, mobileSeparatorStyle } from './invoiceCell.css';
import { InvoiceClientCell } from './InvoiceClientCell';
import { InvoiceDocumentDateCell } from './InvoiceDocumentDateCell';
import { InvoiceOptionsCell } from './InvoiceOptionsCell';
import { InvoiceStatusCell } from './InvoiceStatusCell';
import { InvoiceTitleCell } from './InvoiceTitleCell';
import { InvoiceTotalCell } from './InvoiceTotalCell';

type Props = {
  invoice: Invoice;
  showClient?: boolean;
};

export const InvoiceMobileCell = ({ invoice, showClient = true }: Props) => {
  return (
    <div className={mobileCellStyle}>
      <div className={mobileHeaderStyle}>
        <div>
          <InvoiceTitleCell invoice={invoice} />

          {showClient && <InvoiceClientCell invoice={invoice} />}
        </div>

        <div className={mobileActionsStyle}>
          <InvoiceStatusCell invoice={invoice} />

          <InvoiceOptionsCell invoice={invoice} />
        </div>
      </div>

      <Separator className={mobileSeparatorStyle} />

      <div className={mobileFooterStyle}>
        <InvoiceDocumentDateCell invoice={invoice} />

        <InvoiceTotalCell value={invoice.calculationData.fcExclVat} />
      </div>
    </div>
  );
};
